import { BuildingsActionTypes } from './action-types';
import { BuildingState } from 'models';
import { Reducer } from 'redux';

const initialState: BuildingState = {
  buildingsList: [],
  loading: false,
  error: false,
};

export const reducer: Reducer<BuildingState> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case BuildingsActionTypes.REQUEST_BUILDINGS_START:
      return { ...state, loading: true, error: false };
    case BuildingsActionTypes.REQUEST_BUILDINGS_SUCCESS:
      return { ...state, buildingsList: action.payload, loading: false };
    case BuildingsActionTypes.REQUEST_BUILDINGS_FAILED:
      return { ...state, loading: false, error: true };
    default:
      return state;
  }
};
